<template>
    <div>
        <van-nav-bar
                title="当前库存"
                left-text=""
                right-text="筛选"
                left-arrow
                fixed
                @click-left="back()"
                @click-right="searchPop()"
        />

        <div class="hejcss">合计：数量{{sumData.totalAmount}}件,重量{{sumData.totalWeight}}吨,{{sumData.totalBlock}}块</div>

        <div class="contentwarp">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh"
                              style="height: calc(100vh - 135px); overflow: auto;">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad">
                    <van-cell v-for="item in list" :key="item.id" class="swipewarp">
                        <van-row gutter="20">
                            <van-col span="13" class="ellipsis">
                                入库卡号：{{item.instockCustomerNo}}
                            </van-col>
                            <van-col span="11" class="ellipsisRight">
                                车船箱号：{{item.tscNumber}}
                            </van-col>
                        </van-row>


                        <van-row gutter="20" style="color: #727272">
                            <van-col span="24" class="ellipsis">
                                品名：{{item.cargoName}} {{item.cargoMaterialName}} {{item.cargoModelName}}
                                {{item.cargoOriginName}}
                            </van-col>
                        </van-row>


                        <van-row gutter="20" style="color: #727272">
                            <van-col span="12" class="ellipsis">
                                货位：{{item.wcode?item.wcode+"/":''}}{{item.acode?item.acode+"/":''}}{{item.pcode}}
                            </van-col>
                            <van-col span="12" class="ellipsisRight">
                                数量：{{item.currentAmount}}件,{{item.currentWeight}}吨
                            </van-col>
                        </van-row>
                    </van-cell>
                </van-list>
            </van-pull-refresh>
        </div>

        <van-popup v-model="searchShowPop" position="right" :style="{ height: '100%', width:'90%'}">
            <van-nav-bar
                    title="筛选"
                    fixed
                    z-index="9000"
            />
            <div class="searchwarp">
                <van-field v-model="searchValue.instockCustomerNo" label="入库卡号" placeholder="请输入入库卡号" autocomplete="off"
                           label-width="80px" label-align="right"/>
                <van-field v-model="searchValue.tscNumber" label="车船箱号" placeholder="请输入车船箱号" autocomplete="off"
                           label-width="80px" label-align="right"/>
                <van-field v-model="searchValue.batchNumber" label="批号" placeholder="请输入批号" autocomplete="off"
                           label-width="80px" label-align="right"/>
                <van-field v-model="searchValue.from" label="入库日期" readonly="readonly" placeholder="点击选择日期"
                           autocomplete="off" @click="calendarShow=true" label-width="80px" label-align="right"/>
                <van-field name="radio" label="库存类型" label-width="80px" label-align="right">
                    <template #input>
                        <van-radio-group v-model="searchValue.freezeType" direction="horizontal">
                            <van-radio name="">全部</van-radio>
                            <van-radio name="30">可用</van-radio>
                            <van-radio name="20">锁定</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field :value="selcargoName" readonly name="picker" label="品名" placeholder="点击选择品名"
                           @click="showPicker = true" label-width="80px" label-align="right"/>
                <van-popup v-model="showPicker" position="bottom" :style="{ height: '310px' }">
                    <van-picker
                            title="品名"
                            show-toolbar
                            :columns="cargocol"
                            @confirm="selCargoId"
                            @cancel="showPicker = false"
                    />
                </van-popup>

                <van-field :value="selcargoOrnName" readonly name="picker" label="品牌" placeholder="点击选择品牌"
                           @click="showPickerPP = true" label-width="80px" label-align="right"/>
                <van-popup v-model="showPickerPP" position="bottom" :style="{ height: '310px' }">
                    <van-picker
                            title="品牌"
                            show-toolbar
                            :columns="cargoOrncol"
                            @confirm="selCargoOrgnId"
                            @cancel="showPickerPP = false"/>
                </van-popup>
                <van-row gutter="20" style="margin-top:20px;margin-bottom:20px">
                    <van-col span="8" offset="4">
                        <van-button block size="small" type="info" native-type="submit" class="button"
                                    @click="resetSearch()">
                            重置
                        </van-button>
                    </van-col>
                    <van-col span="8">
                        <van-button block size="small" type="info" native-type="submit" class="button"
                                    @click="onSearch()">
                            确定
                        </van-button>
                    </van-col>
                </van-row>
                <van-calendar v-model="calendarShow"
                              :min-date=" new Date(2020, 9, 1)"
                              type="range" @confirm="calendarConfirm"/>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {
        Button,
        Calendar,
        Cell,
        Col,
        Divider,
        Field,
        Form,
        Grid,
        GridItem,
        Icon,
        Image as VanImage,
        ImagePreview,
        Lazyload,
        List,
        NavBar,
        Picker,
        Popup,
        PullRefresh,
        Radio,
        RadioGroup,
        Row,
        Search,
        Sticky,
        SwipeCell,
        Toast
    } from 'vant';
    import service from '../../server/index'

    Vue.use(Lazyload, {
        lazyComponent: true,
    });

    export default {
        name: "Fleet",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [SwipeCell.name]: SwipeCell,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Divider.name]: Divider,
            [VanImage.name]: VanImage,
            [ImagePreview.Component.name]: ImagePreview.Component,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Form.name]: Form,
            [Picker.name]: Picker
        },
        data() {
            return {
                list: [],
                loading: true,
                finished: false,
                searchValue: {},
                selcargoName: "",
                selcargoOrnName: "",
                cargoData: [],
                cargoOrnData: [],
                cargoOrncol: [],
                cargocol: [],
                showPicker: false,
                showPickerPP: false,
                searchShowPop: false,
                isLoading: false,
                page: 1,
                calendarShow: false,
                sumData: {
                    totalBlock: "--",
                    totalWeight: "--",
                    totalAmount: "--"
                },
            }
        },
        mounted() {
            this.onLoad();
            let param = {};
            param.ouid = localStorage.getItem("ouid")
            service.selOuCargoG(param).then(res => {
                let data = res.data;
                this.cargoData = data
                for (let i = 0; i < data.length; i++) {
                    this.cargocol.push(data[i].cargoName)
                }
            })
        },
        methods: {
            back() {
                this.$router.replace("/Home/Search")
            },
            selCargoId(value, index) {
                this.selcargoName = value;
                this.searchValue.cargoId = this.cargoData[index].cargoId
                this.showPicker = false;

                let param = {};
                param.ouid = localStorage.getItem("ouid")
                param.cargoId = this.cargoData[index].cargoId
                service.selCargoOriginG(param).then(res => {
                    let data = res.data;
                    this.cargoOrnData = data
                    this.cargoOrncol = []
                    for (let i = 0; i < data.length; i++) {
                        this.cargoOrncol.push(data[i].cargoOriginName)
                    }
                    this.selcargoOrnName = ""
                    this.searchValue.cargoOriginId = ""
                })

            },
            selCargoOrgnId(value, index) {
                this.selcargoOrnName = value;
                this.searchValue.cargoOriginId = this.cargoOrnData[index].cargoOriginId
                this.showPickerPP = false;
            },
            onSearch() {
                this.list = [];
                this.page = 1;
                this.searchShowPop = false;
                this.onLoad();
            },
            onLoad() {
                let param = this.searchValue
                param.size = 10
                param.page = this.page
                param.ouid = localStorage.getItem("ouid")
                param.customerId = localStorage.getItem("customerId")
                param.customerFutureTempName = ""
                this.selSumData()
                service.searchCurrentStorageTotal(param).then((res) => {
                    if (res.code == "200") {
                        if (res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.push(res.data[i]);
                            }
                            this.page++
                        } else {
                            this.finished = true;
                        }

                        // 加载状态结束
                        this.loading = false;
                        this.isLoading = false;
                    } else {
                        this.loading = false;
                        this.finished = true;
                        this.isLoading = false;
                        Toast(res.message)
                    }

                }).catch((res) => {
                    this.loading = false;
                    this.finished = true;
                    Toast(res.message)
                });
            },
            selSumData() {
                this.searchValue.customerId = localStorage.getItem("customerId")
                service.selCurrentStorageSum(this.searchValue).then(res => {
                    if (res.code === '200' && res.data) {
                        this.sumData = res.data;
                    } else {
                        this.sumData = {
                            totalBlock: "--",
                            totalWeight: "--",
                            totalAmount: "--"
                        }
                    }
                })
            },
            searchPop() {
                this.searchShowPop = true;
            },
            onRefresh() {
                this.onLoad();
            },
            //日期组件
            formatDate(date) {
                return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            },
            calendarConfirm(date) {
                const [start, end] = date;
                this.calendarShow = false;
                this.searchValue.from = `${this.formatDate(start)} - ${this.formatDate(end)}`;
                this.searchValue.instockDateStart = this.$moment(start).format("YYYY-MM-DD");
                this.searchValue.instockDateEnd = this.$moment(end).format("YYYY-MM-DD");
            },
            resetSearch() {
                this.searchValue = {};
                this.selcargoName = "";
                this.selcargoOrnName = "";
                this.finished = false
            },
        }
    }
</script>

<style scoped>
    .van-popup {
        background-color: #f7f8fa;
    }

    .hejcss {
        position: fixed;
        bottom: 50px;
        left: 0;
        z-index: 999;
        box-sizing: border-box;
        width: 100%;
        padding: 8px;
        background-color: #f7f8fa;
        font-size: 15px;
    }

    .searchwarp {
        margin-top: 46px;
    }

    .editwarp {
        width: 100%;
        margin: 56px auto;
    }

    .editwarp .swipewarp {
        margin-bottom: 10px;
    }

    .contentwarp {
        margin-top: 50px;
        height: calc(100vh - 135px);
    }

    .detailHeader {
        background-color: #1989fa;
        height: 70px;
        text-align: center;
        padding-top: 20px;
        margin-bottom: 20px;
        color: white;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    .detailLabel {
        color: #727272;
    }

    .detailLabel.detailtitle {
        color: #323233;
        font-weight: bold;
    }

    /deep/ .van-nav-bar .van-icon,
    /deep/ .van-nav-bar__text,
    /deep/ .van-calendar__day--middle,
    .van-icon.van-icon-arrow {
        color: #6685a4;
    }

    /deep/ .van-button--info,
    /deep/ .van-button--danger {
        /*background-color: #6685a4 ;*/
        /*border: 1px solid #6685a4 ;*/
        background-color: white;
        border: 1px solid white;
        color: #6685a4;
    }

    /deep/ .van-button--warning {
        background-color: #6685a4;
        border: 1px solid #6685a4;
    }

    /deep/ .ewm .van-button--info {
        border: 1px solid #6685a4;
        width: 200px
    }


    .searchwarp[data-v-1405fac1] {
        margin-top: 56px;
    }

    /deep/ .van-calendar__day--start,
    /deep/ .van-calendar__day--end,
    /deep/ .detailHeader[data-v-1405fac1] {
        background-color: #6685a4;
    }

    /deep/ .van-calendar__day--middle {
        background-color: #e4ebf3;
    }

    /*.van-cell::after{
        border-bottom: none;
    }*/
    .van-icon.van-icon-arrow {
        vertical-align: middle;
        margin-left: 5px;
    }

    .van-grid {
        padding: 10px;
    }

    /deep/ .van-image__img {
        border: #e4ebf3 1px solid;
    }

    .closebutton {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0px;
        height: 50px;
        width: 100% !important;
        /*font-size: 12px;*/
        z-index: 9999;
    }

    .van-button--default {
        border: 1px solid #e2e2e2;
    }

    .van-divider {
        margin: 0px !important;
    }


    /deep/ .thmx > .van-row {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    /deep/ .van-cell__value.van-cell__value--alone > .thmx:last-child > .van-row {
        padding-top: 10px;
        padding-bottom: 0;
    }

    .button {
        font-size: 16px;
        color: #ffffff;
        background: #6685a4;
        height: 32px;
    }

    .van-cell {
        padding: 8px 16px;
        font-size: 15px;
    }

    .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .ellipsisRight {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: right;
    }
</style>
